import { api } from '_shared/_stores/api';
import Guid from '_shared/guids/guid';
import UserInformationSchema, { UserInformationJSON } from 'users/information/_schemas/user-information-schema';
import NetworkConnectionForumSchema, { NetworkConnectionForumJSON } from 'users/networking/connections/_schemas/network-connection-forum-schema';
import z from 'zod';

export const userNetworkConnectionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    // #region Get
    getUserNetworkConnections: (
      build.query<UserInformationJSON[], void>({
        query: () => ({
          url: 'users/network-connections'
        }),
        rawResponseSchema: z.array(UserInformationSchema.UserInformationJSONZ),
        providesTags: (result) =>
          result
            ? [
              { type: "UserNetworkConnection" as const, id: "LIST" },
              ...result.map(({ id }) => ({ type: "UserNetworkConnection" as const, id: id })),
            ]
            : [{ type: "UserNetworkConnection" as const, id: "LIST" }],

      })
    ),
    getChatForumForNetworkConnection: (
      build.query<NetworkConnectionForumJSON, { userId: Guid }>({
        query: ({ userId }) => ({
          url: `users/network-chat/${userId.value}`
        }),
        rawResponseSchema: NetworkConnectionForumSchema.NetworkConnectionForumJSONZ.nullish(),
        providesTags: (result, error, id) => [{
          type: 'UserNetworkConnection',
          id: id.userId.value
        }],
      })
    ),
    // #endregion

    // #region Delete
    removeNetworkConnection: (
      build.mutation<void, { connectionId: Guid }>({
        query: ({ connectionId }) => ({
          url: `users/network-connections/${connectionId.value}`,
          method: 'DELETE'
        }),
        invalidatesTags: (result, error, id) => [
          {
            type: 'UserNetworkConnection',
            id: id.connectionId.value
          },
          {
            type: 'UserNetworkConnection',
            id: 'LIST'
          }
        ]
      })
    ),
    // #endregion

    // #region Create
    createChatForumForNetworkConnection: (
      build.mutation<NetworkConnectionForumJSON, { connectionId: Guid }>({
        query: ({ connectionId }) => ({
          url: `users/network-chat/${connectionId.value}/create`,
          method: 'POST'
        }),
        rawResponseSchema: NetworkConnectionForumSchema.NetworkConnectionForumJSONZ.nullish(),
        invalidatesTags: [{
          type: 'UserNetworkConnection',
          id: 'LIST'
        }]
      })
    ),
    // #endregion
  })
});

export const {
  useGetUserNetworkConnectionsQuery,
  useGetChatForumForNetworkConnectionQuery,
  useRemoveNetworkConnectionMutation,
  useCreateChatForumForNetworkConnectionMutation
} = userNetworkConnectionsApi;
